
import { Component, Vue } from "vue-property-decorator";

interface HouseType {
  name: string;
  url: string;
}

@Component
export default class HouseClass extends Vue {
  private houseType: HouseType[] = [
    {
      name: "合租",
      url: require("@/assets/hezu.png")
    },
    {
      name: "短租",
      url: require("@/assets/duanzu.png")
    },
    {
      name: "整租",
      url: require("@/assets/zhengzu.png")
    },
    {
      name: "免押金",
      url: require("@/assets/mianya.png")
    }
  ];

  render() {
    return (
      <div class="home-class">
        {this.houseType.map(type => (
          <a-card hoverable style="width: 240px" key={type.name}>
            <img src={type.url} slot="cover" width="238px" height="172.45px;" />
            <a-card-meta>
              <template slot="description">
                <div class="dec">
                  <div>
                    <span class="title">{type.name}</span>
                  </div>
                  <div>
                    <a-button class="ty-btn">点击查看</a-button>
                  </div>
                </div>
              </template>
            </a-card-meta>
          </a-card>
        ))}
      </div>
    );
  }
}
